import React from 'react';
import { Avatar } from '@producer/ui-kit';
import { getNameInitials } from '../../../lib/utils/get-name-initials';

import styles from './project-contact-item.module.scss';
type ProjectContactProps = {
  avatar: string;
  position: string;
  name: string;
};

export const ProjectContactItem: React.FC<ProjectContactProps> = ({ avatar, position, name }) => (
  <div className={styles['container']}>
    <Avatar src={avatar} theme="dark" initials={getNameInitials(name)} />

    <div className={styles['content']}>
      <p className={styles['name']}>{name}</p>
      <p className={styles['position']}>{position}</p>
    </div>
  </div>
);
